import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import consentAPI from "../../../apiConfig/consentAPI";
import { CollectionPoint } from "../../../constants/consent";

export const status = {
  INITIAL: "INITIAL",
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR",
};

const initialState = {
  consents: null,
  status: status.INITIAL,
  errorMessage: null,
  visitedConsentPage: false,
};

//Thunks
export const fetchAsyncConsent = createAsyncThunk(
  "consent/fetchAsyncConsent",
  async (collectionPoint, { rejectWithValue }) => {
    try {
      let language = localStorage.getItem("lang");
      language === "en-US" && (language = "en");
      const response = await consentAPI.post("/required-consent", {
        language,
        collectionPoint: CollectionPoint.OPEN_APP,
        isFilterActive: collectionPoint === CollectionPoint.OPEN_APP,
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

//Slices
const ConsentSlice = createSlice({
  name: "consent",
  initialState,
  reducers: {
    resetConsent: state => {
      state.consents = null;
      state.status = status.INITIAL;
      state.errorMessage = null;
    },
    setVisitedConsentPage: state => {
      state.visitedConsentPage = true;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncConsent.pending, state => {
        state.status = status.LOADING;
        state.errorMessage = null;
      })
      .addCase(fetchAsyncConsent.fulfilled, (state, { payload }) => {
        state.consents = payload;
        state.status = status.LOADED;
        state.errorMessage = null;
      })
      .addCase(fetchAsyncConsent.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = status.ERROR;
      });
  },
});

export const { resetConsent, setVisitedConsentPage } = ConsentSlice.actions;

export default ConsentSlice.reducer;
